import * as React from 'react';
import { CreateAccountForm } from './CreateAccountForm';
import { useParams } from "react-router"

export const CreateAccount = () => {
  const { system }: any = useParams();
  return <CreateAccountForm system={system} />;
}